import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { isMobile } from 'react-device-detect';

import { Input } from 'components/FormComponents/FormComponents';
import { Modal, Header, Body, Footer, FooterButton } from '../modalElements';
import services from 'api/services';
import { isValidEmail } from 'functions/stringValidation';
const { AccountService } = services;

export default function FreecodeMobilePromptModal({ type, id }) {
  const [isModalOpen, setIsModalOpen] = useState(localStorage.getItem('fsEditor-isMobileInfoPrompted') !== 'true');
  const [email, setEmail] = useState('');

  const sendReminderEmail = async () => {
    try {
      if (!isValidEmail(email)) return toast.error('Email is not valid');
      await AccountService.sendFreecodeLinkEmail({ email, type, id });
      toast.success('Email sent successfully');
      closeModal();
    } catch (error) {
      toast.error(error.message?.[0] ?? error.message ?? 'Error sending email');
    }
  };

  const closeModal = () => {
    localStorage.setItem('fsEditor-isMobileInfoPrompted', true);
    setIsModalOpen(false);
  };

  return (
    isMobile &&
    isModalOpen && (
      <Modal isOpen={isModalOpen}>
        <Header>Information</Header>
        <Body>
          <p>
            For an improved experience we at Future Skill would like to recommend that you explore this {type} using a
            large screen device. If you enter your email below we will send you a reminder with a link, so you can
            easily restart at your convenience.
          </p>
          <Input type="text" autoFocus value={email} placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
        </Body>
        <Footer>
          <FooterButton label="Close" onClick={closeModal} />
          <FooterButton label="Submit" onClick={sendReminderEmail} />
        </Footer>
      </Modal>
    )
  );
}
